var React = require('react');

function ArrowSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

ArrowSmall.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowSmall;

ArrowSmall.default = ArrowSmall;
